export default __webpack_public_path__ + "static/messages-inline-dialog-0682c0b3958e1012ee062068dc201cd9.jpg";